<template>
    <div class="title-component">
        <div class="row" v-if="computedTitle === 'Organize my funeral'">
            <div class="col title title-first-letter">
                <h1>{{computedTitle}}</h1>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col title">
                <h1>{{computedTitle}}</h1>
            </div>
        </div>
        <div class="row description">
            <div class="col">
                <h3>{{computedDescription}}</h3>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import i18n from '../../assets/i18n/lang'
    import {
        TITLE_NAMESPACE,
        TITLE_ACTION_GET_TITLE
    } from '../../store/modules/title-types'

    export default {
        name: 'Title',
        computed: {
            ...mapState({
                title: state => state.title.title
            }),
            computedTitle: function () {
                return i18n.t('title.' + this.title.key + '.title')
            },
            computedDescription: function () {
                return i18n.t('title.' + this.title.key + '.description')
            }
        },
        methods: {
            ...mapActions(TITLE_NAMESPACE, {
                loadTitle: TITLE_ACTION_GET_TITLE
            })
        },
        created () {
            this.loadTitle()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom';

    .title-component {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title {
        font-family: 'alfa-regular', Arial, sans-serif;
        text-transform: uppercase;
    }

    .title-first-letter::first-letter {
        color: $omyfu-yellow;
    }

    .description {
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/TitleComponent.vue